import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { getDatabase, ref, get } from 'firebase/database';

const AdminLogin = () => {
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const [loginData, setLoginData] = useState({
    email: '',
    password: ''
  });

  const validateEmail = (email) => /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateEmail(loginData.email)) {
      toast.error('Please enter a valid email address');
      return;
    }
    
    if (!loginData.password) {
      toast.error('Password is required');
      return;
    }

    setLoading(true);
    
    try {
      const auth = getAuth();
      const database = getDatabase();
      
      const userCredential = await signInWithEmailAndPassword(auth, loginData.email, loginData.password);
      const uid = userCredential.user.uid;

      // Check if user is admin
      const adminSnapshot = await get(ref(database, `admins/${uid}`));
      
      if (adminSnapshot.exists()) {
        const adminData = adminSnapshot.val();
        
        toast.success('Login successful!');
        
        localStorage.setItem('userId', uid);
        localStorage.setItem('userRole', 'admin');
        localStorage.setItem('userEmail', adminData.email);
        localStorage.setItem('userName', `${adminData.firstName} ${adminData.lastName}`);
        localStorage.setItem('companyName', adminData.companyName);
        
        setTimeout(() => {
          window.location.href = '/admin-dashboard';
        }, 1000);
      } else {
        toast.error('Access denied. Admin account not found.');
        await auth.signOut();
      }
      
      setLoading(false);
      
    } catch (error) {
      setLoading(false);
      if (error.code === 'auth/user-not-found') {
        toast.error('Admin account not found');
      } else if (error.code === 'auth/wrong-password') {
        toast.error('Incorrect password');
      } else if (error.code === 'auth/invalid-email') {
        toast.error('Invalid email address format');
      } else {
        toast.error('Login failed: ' + error.message);
      }
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#1e293b', padding: '20px' }}>
      <ToastContainer />
      <div style={{ maxWidth: '500px', margin: '0 auto', paddingTop: '60px' }}>
        <div style={{ 
          backgroundColor: 'white', 
          borderRadius: '12px', 
          padding: '40px', 
          boxShadow: '0 10px 25px rgba(0,0,0,0.2)' 
        }}>
          <div style={{ textAlign: 'center', marginBottom: '30px' }}>
            <div style={{ 
              width: '60px', 
              height: '60px', 
              backgroundColor: '#dc2626', 
              borderRadius: '50%', 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center',
              margin: '0 auto 16px'
            }}>
              <span style={{ fontSize: '30px' }}>🔐</span>
            </div>
            <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#1F2937', marginBottom: '8px' }}>
              Admin Login
            </h1>
            <p style={{ fontSize: '14px', color: '#6B7280' }}>
              Access your admin dashboard
            </p>
          </div>
          
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: '16px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
                Email Address <span style={{ color: 'red' }}>*</span>
              </label>
              <input 
                type="email"
                value={loginData.email}
                onChange={(e) => setLoginData({...loginData, email: e.target.value})}
                placeholder="admin@company.com"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '2px solid #E5E7EB',
                  borderRadius: '10px',
                  fontSize: '14px',
                  outline: 'none'
                }}
                required
              />
            </div>

            <div style={{ marginBottom: '24px' }}>
              <label style={{ display: 'block', fontSize: '14px', fontWeight: 600, color: '#374151', marginBottom: '8px' }}>
                Password <span style={{ color: 'red' }}>*</span>
              </label>
              <div style={{ position: 'relative' }}>
                <input 
                  type={showPassword ? 'text' : 'password'}
                  value={loginData.password}
                  onChange={(e) => setLoginData({...loginData, password: e.target.value})}
                  placeholder="••••••••"
                  style={{
                    width: '100%',
                    padding: '12px 48px 12px 12px',
                    border: '2px solid #E5E7EB',
                    borderRadius: '10px',
                    fontSize: '14px',
                    outline: 'none'
                  }}
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: 'absolute',
                    right: '12px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    background: 'none',
                    border: 'none',
                    cursor: 'pointer',
                    color: '#9CA3AF',
                    padding: '4px'
                  }}
                >
                  {showPassword ? 'Hide' : 'Show'}
                </button>
              </div>
            </div>
            
            <button 
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '14px',
                borderRadius: '8px',
                fontWeight: 600,
                color: 'white',
                fontSize: '16px',
                border: 'none',
                cursor: loading ? 'not-allowed' : 'pointer',
                backgroundColor: loading ? '#9CA3AF' : '#dc2626'
              }}
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
          
          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <p style={{ color: '#6B7280', fontSize: '14px' }}>
              Don't have an admin account? <a href="/admin-register" style={{ color: '#dc2626', fontWeight: 600 }}>Register here</a>
            </p>
          </div>

          <div style={{ textAlign: 'center', marginTop: '16px' }}>
            <a href="/" style={{ color: '#6B7280', fontSize: '14px', textDecoration: 'none' }}>
              ← Back to Home
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
